import { AreaChart, Area, XAxis, YAxis, Tooltip, ResponsiveContainer } from "recharts";
import { fmtCurrency } from "@/lib/api";

const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

const CHART_MARGIN = { top: 10, right: 8, left: 8, bottom: 0 };
const AXIS_TICK = { fill: "#94a3b8", fontSize: 12 };

const CustomTooltip = ({ active, payload }) => {
  if (!active || !payload?.length) return null;
  const p = payload[0].payload;
  return (
    <div className="bg-white border border-slate-200 rounded-xl shadow-lg px-3 py-2">
      <p className="text-xs text-slate-400 mb-0.5">{p.date}</p>
      <p className="text-sm font-semibold text-[#15803d] tabular-nums">{fmtCurrency(payload[0].value)}</p>
    </div>
  );
};

export default function PerformanceChart({ data, xMode = "month", height = 280, color = "#15803d" }) {
  const fmtTick = (v) => {
    if (!v || typeof v !== "string") return "";
    const [y, m, d] = v.split("-").map(Number);
    if (!m) return v;
    if (xMode === "year") return String(y);
    if (xMode === "day") return `${d || 1} ${MONTHS[m - 1]}`;
    return `${MONTHS[m - 1]} '${String(y).slice(2)}`;
  };

  return (
    <ResponsiveContainer width="100%" height={height}>
      <AreaChart data={data} margin={CHART_MARGIN}>
        <defs>
          <linearGradient id="perfGrad" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor={color} stopOpacity={0.22} />
            <stop offset="100%" stopColor={color} stopOpacity={0} />
          </linearGradient>
        </defs>
        <XAxis dataKey="date" tickFormatter={fmtTick} tickLine={false} axisLine={false}
          tick={AXIS_TICK} dy={8} minTickGap={40} interval="preserveStartEnd" />
        <YAxis tickFormatter={(v) => `₹${Math.round(v / 1000)}k`} tickLine={false} axisLine={false}
          tick={AXIS_TICK} width={52} />
        <Tooltip content={<CustomTooltip />} />
        <Area type="monotone" dataKey="value" stroke={color} strokeWidth={2.5}
          fill="url(#perfGrad)" dot={false} activeDot={{ r: 4, fill: color }} />
      </AreaChart>
    </ResponsiveContainer>
  );
}
